import { useEffect, useState } from 'react';
import { OptionProps } from './segments-drawer.types';
import { textSegmentsByTeam } from './segments.utils';

export const useCountSegments = (options: OptionProps[]) => {
    const [segmentsByPareto, setSegmentsByPareto] = useState(0);
    const [segmentsByTeam, setSegmentsByTeam] = useState(0);


    useEffect(() => {
        const countPareto = options
            .filter(option => !option.isDeletable && !option.isEditable)
            .length;

        const countTeam = options
            .filter(option => option.isDeletable && option.isEditable)
            .length;

        setSegmentsByPareto(countPareto);
        setSegmentsByTeam(countTeam);
    }, [options]);

    return { segmentsByPareto, segmentsByTeam: textSegmentsByTeam(segmentsByTeam) };
};
